import React from 'react';
import { LogOut, RefreshCw } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  onLogout?: () => void;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, onLogout, actions }) => {
  return (
    <div className="sticky top-0 z-10 bg-zinc-50 border-b border-zinc-200 px-4 md:px-8 py-4 flex items-center justify-between gap-4">
      <div>
        <h2 className="text-xl md:text-2xl font-black text-zinc-900 tracking-tight uppercase">
          {title}
        </h2>
        {subtitle && <p className="text-zinc-500 text-sm mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        {actions}
        {onLogout && (
          <button
            onClick={onLogout}
            className="flex items-center gap-2 px-3 py-2 rounded-lg border border-zinc-200 bg-white text-zinc-600 hover:text-zinc-900 hover:border-zinc-300 transition-all text-sm font-medium"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline">Logout</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
